import React from 'react';
import LegalLayout from '../../components/LegalLayout';

const Cookies = () => (
  <LegalLayout title="MyBusinessAdPro Cookie Policy" lastUpdated="February 2026">
    <p>This Cookie Policy explains how MyBusinessAdPro uses cookies and similar tracking technologies when you visit <strong>mybusinessadpro.co.uk</strong>, the customer dashboard, or any sub-domain.</p>

    <h2>1. What are cookies?</h2>
    <p>Cookies are small text files placed on your device by websites you visit. They are widely used to make websites work, or work more efficiently, as well as to provide reporting information and to personalise content.</p>

    <h2>2. The cookies we use</h2>
    <h3>2.1 Strictly necessary (always on — no consent required)</h3>
    <table>
      <thead><tr><th>Cookie</th><th>Purpose</th><th>Duration</th></tr></thead>
      <tbody>
        <tr><td><code>mbap_token</code> / JWT</td><td>Keeps you signed in</td><td>30 days</td></tr>
        <tr><td><code>csrf_token</code></td><td>Prevents cross-site request forgery</td><td>Session</td></tr>
        <tr><td><code>mbap_visitor_id</code></td><td>Anonymous unique visitor ID for analytics dedupe</td><td>1 year</td></tr>
        <tr><td><code>mbap_whatsapp_popup_state</code></td><td>Remembers if you've dismissed or subscribed to the WhatsApp popup so we don't pester you</td><td>3 days — permanent on opt-out</td></tr>
        <tr><td><code>__cf_bm</code></td><td>Bot / abuse prevention set by our CDN (Cloudflare)</td><td>30 minutes</td></tr>
        <tr><td>Stripe cookies</td><td>Set by Stripe when you open the payment portal — fraud prevention</td><td>Up to 1 year</td></tr>
      </tbody>
    </table>

    <h3>2.2 Analytics (consent-based)</h3>
    <table>
      <thead><tr><th>Cookie</th><th>Purpose</th><th>Duration</th></tr></thead>
      <tbody>
        <tr><td>Internal <code>mbap_session</code></td><td>Page-view tracking &amp; bot detection</td><td>30 min</td></tr>
      </tbody>
    </table>

    <h3>2.3 Marketing (consent-based)</h3>
    <table>
      <thead><tr><th>Cookie</th><th>Purpose</th><th>Duration</th></tr></thead>
      <tbody>
        <tr><td>Meta Pixel (<code>_fbp</code>)</td><td>Conversion tracking for Meta ads (only if you enable it)</td><td>3 months</td></tr>
        <tr><td>Google Analytics / GBP</td><td>Attribution for Google Ads &amp; Business Profile (only if you enable it)</td><td>2 years</td></tr>
      </tbody>
    </table>

    <h2>3. Your choices</h2>
    <p>You can:</p>
    <ul>
      <li>Accept or reject non-essential cookies via the banner shown on your first visit.</li>
      <li>Change your preferences at any time at <strong>/privacy-settings</strong> (logged in) or by clearing cookies in your browser.</li>
      <li>Use browser privacy tools or extensions to block categories of cookies.</li>
    </ul>
    <p>Rejecting non-essential cookies will not prevent you from using the site, but some analytics and personalisation features will not work.</p>

    <h2>4. Third-party cookies</h2>
    <p>Third-party services (Meta, Google, Stripe checkout) may set their own cookies when you interact with their embedded elements. Their use is governed by their own privacy and cookie policies:</p>
    <ul>
      <li>Meta: <a href="https://facebook.com/policies/cookies" target="_blank" rel="noopener noreferrer">facebook.com/policies/cookies</a></li>
      <li>Google: <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">policies.google.com/technologies/cookies</a></li>
      <li>Stripe: <a href="https://stripe.com/cookie-settings" target="_blank" rel="noopener noreferrer">stripe.com/cookie-settings</a></li>
    </ul>

    <h2>5. Changes to this policy</h2>
    <p>We may update this Cookie Policy to reflect changes in technology, regulation, or our practices. We will update the "Last updated" date at the top whenever a change is made.</p>

    <h2>6. Contact</h2>
    <p>Questions about cookies: <a href="mailto:contact@mybusinessadpro.co.uk">contact@mybusinessadpro.co.uk</a></p>
  </LegalLayout>
);
export default Cookies;
